var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodcast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 80,
    viewBox: "0 0 48 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9503 50.7275C19.2943 51.4526 14.4549 47.0439 14.4549 41.5275V39.5155C14.4549 38.5405 13.6762 37.7444 12.7022 37.722L12.7021 37.722C11.6951 37.6987 10.8669 38.5083 10.8669 39.5155V41.1302C10.8669 47.857 15.8485 53.7105 22.492 54.3358C30.1436 55.0559 36.6015 49.0306 36.6015 41.5275V14.8555C36.6015 8.13012 31.6199 2.27659 24.9764 1.65127C17.3248 0.931114 10.8669 6.95515 10.8669 14.4595V27.4075C10.8669 28.3986 11.6702 29.2018 12.6595 29.2009H12.6602C13.6511 29.2009 14.4549 28.3975 14.4549 27.4075V14.7582C14.4549 10.0791 17.8116 5.86232 22.5166 5.25829L22.5168 5.25828C28.1728 4.53314 33.0122 8.94193 33.0122 14.4595V41.2275C33.0122 45.9078 29.6556 50.1248 24.9503 50.7275ZM24.9503 50.7275L24.8655 50.0662M24.9503 50.7275L24.8655 50.0662M24.8655 50.0662C29.2069 49.5102 32.3455 45.6049 32.3455 41.2275V14.4595C32.3455 9.3382 27.8535 5.2462 22.6015 5.91953L12.6602 29.8675C11.3015 29.8689 10.2002 28.7662 10.2002 27.4075V14.4595C10.2002 6.5662 16.9922 0.230202 25.0389 0.987537C32.0509 1.64754 37.2682 7.81287 37.2682 14.8555V41.5275C37.2682 49.4195 30.4762 55.7569 22.4295 54.9995C15.4175 54.3395 10.2002 48.1742 10.2002 41.1302V39.5155C10.2002 38.1342 11.3362 37.0235 12.7175 37.0555C14.0535 37.0862 15.1215 38.1782 15.1215 39.5155V41.5275C15.1215 46.6475 19.6135 50.7395 24.8655 50.0662Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.33333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3421 64.1391L21.9391 64.2019V64.8021V74.7461V75.4128H21.2724H8.96978C7.97883 75.4128 7.17511 76.2161 7.17511 77.2061C7.17511 78.1966 7.9793 79.0008 8.96978 79.0008H38.4978C39.4878 79.0008 40.2911 78.1971 40.2911 77.2061C40.2911 76.2157 39.4883 75.4128 38.4978 75.4128H26.1938H25.5271V74.7461V64.8021V64.2019L26.1241 64.1391C37.5261 62.941 46.4431 53.2703 46.4431 41.5568V32.9435C46.4431 31.953 45.6402 31.1502 44.6498 31.1502C43.6577 31.1502 42.8551 31.9532 42.8551 32.9435V41.5568C42.8551 52.101 34.278 60.6781 23.7338 60.6781C13.1896 60.6781 4.61111 52.1011 4.61111 41.5568V32.3288C4.61111 31.3379 3.80778 30.5342 2.81777 30.5342C1.8273 30.5342 1.02311 31.3383 1.02311 32.3288V41.5568C1.02311 53.2716 9.94012 62.941 21.3421 64.1391Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.33333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4775 16.4419H20.6269H13.4775Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4775 16.4419H20.6269",
    stroke: "currentColor",
    strokeWidth: 4.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4775 23.4939H20.6269H13.4775Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4775 23.4939H20.6269",
    stroke: "currentColor",
    strokeWidth: 4.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodcast);
export default __webpack_public_path__ + "static/media/podcast.2a2eea226ca89273e9de747e9943bcfc.svg";
export { ForwardRef as ReactComponent };